import { Graphics, Container, Text, Point, ObservablePoint, Texture, extras } from 'pixi.js'
import helpers from '../helpers'
import { app, grid } from './index'
import ItemController from './ItemController'
import Room from './Room'

export default class Item extends Graphics {

  constructor(config, item) {
    super()

    // id
    this.id = item ? item.id : grid.uniqueId()

    // アイテム定義
    this.config = config

    // 寸法
    this.dimension = new ObservablePoint(this.updateDimension, this, 0, 0)

    // 座標
    this.coordinate = new ObservablePoint(this.updateCoordinate, this, item ? item.x : 0, item ? item.y : 0)

    // 角度
    this.angle = item ? item.rotation : 0

    // 読み込み済みか
    this.loaded = false

    this.controller = null

    // 描画エリア
    this.area = new Graphics()
    this.area.name = 'area'
    this.addChild(this.area)

    // テクスチャ
    if (helpers.methods.useSvg()) {
      this.texture = new PIXI.Texture.fromImage(this.config.svg_url, false, PIXI.SCALE_MODES.LINEAR, app.renderer.resolution)
    } else {
      this.texture = new PIXI.Texture.fromImage(this.config.img_url, false, PIXI.SCALE_MODES.LINEAR, app.renderer.resolution)
    }

    // スプライト
    this.sprite = new PIXI.Sprite.from(this.texture)
    this.sprite.scale.set(1 / app.renderer.resolution)
    this.area.addChild(this.sprite)

    let flipX = item ? (item.width > 0 ? 1 : -1) : 1
    let flipY = item ? (item.height > 0 ? 1 : -1) : 1
    if (this.texture.baseTexture.hasLoaded) {
      this.loaded = true
      this.dimension.set(
        flipX * Math.ceil( this.texture.width / grid.cellSize / app.renderer.resolution * grid.division ) / grid.division,
        flipY * Math.ceil( this.texture.height / grid.cellSize / app.renderer.resolution * grid.division ) / grid.division
      )
    } else {
      this.texture.baseTexture.once('loaded', texture => {
        this.loaded = true
        this.dimension.set(
          flipX * Math.ceil( this.texture.width / grid.cellSize / app.renderer.resolution * grid.division ) / grid.division,
          flipY * Math.ceil( this.texture.height / grid.cellSize / app.renderer.resolution * grid.division ) / grid.division
        )
        this.emit('loaded')
      })
    }

    // コントローラー
    this.controller = new ItemController(this)

    this.bindEvents()

    return this
  }

  get room() {
    if (this.parent && this.parent.parent instanceof Room) {
      return this.parent.parent
    } else {
      return null
    }
  }

  get calcWidth() {
    return grid.size * Math.abs(this.angle % 180 == 0 ? this.dimension.x : this.dimension.y)
    // let width = this.angle % 180 == 0 ? this.texture.width : this.texture.height
    // return grid.size * Math.ceil( width / grid.cellSize / app.renderer.resolution * grid.division ) / grid.division
  }

  get calcHeight() {
    return grid.size * Math.abs(this.angle % 180 != 0 ? this.dimension.x : this.dimension.y)
    // let height = this.angle % 180 != 0 ? this.texture.width : this.texture.height
    // return grid.size * Math.ceil( height / grid.cellSize / app.renderer.resolution * grid.division ) / grid.division
  }

  update(silent = false) {
    this.updateDimension(silent)
    this.updateCoordinate(silent)
  }

  updateDimension(silent = false) {

    // スプライト
    this.sprite.width = grid.zoom * this.texture.width / app.renderer.resolution
    this.sprite.height = grid.zoom * this.texture.height / app.renderer.resolution

    this.updateArea()
    if (silent == false) {
      this.emit('updatedimension')
    }
  }

  updateCoordinate(silent = false) {
    this.position.set(this.coordinate.x * grid.size, this.coordinate.y * grid.size)
    this.roomStick()
    if (silent == false) {
      this.emit('updatecoordinate')
    }
  }

  updateArea() {
    // // ガイド
    // this.clear()
    // this.lineStyle(1, 0xff0000)
    // this.beginFill(0xff0000, 0.25)
    // this.drawRect(0, 0, this.calcWidth, this.calcHeight)
    // this.beginFill(0xff0000, 1)
    // this.drawCircle(0, 0, 2)

    this.area.scale.set(this.dimension.x > 0 ? 1 : -1, this.dimension.y > 0 ? 1 : -1)
    this.area.rotation = this.angle * (Math.PI / 180)

    let flipX = (this.angle % 180 == 0 ? this.dimension.x : this.dimension.y) < 0
    let flipY = (this.angle % 180 != 0 ? this.dimension.x : this.dimension.y) < 0
    switch (this.angle) {
      case 0:
        this.area.position.set(!flipX ? 0 : this.calcWidth, !flipY ? 0 : this.calcHeight)
        break
      case 90:
        this.area.position.set(!flipX ? this.calcWidth : 0, !flipY ? 0 : this.calcHeight)
        break
      case 180:
        this.area.position.set(!flipX ? this.calcWidth : 0, !flipY ? this.calcHeight : 0)
        break
      case 270:
        this.area.position.set(!flipX ? 0 : this.calcWidth, !flipY ? this.calcHeight : 0)
        break
    }

    // this.area.clear()
    // this.area.beginFill(0x0000ff, 0.25)
    // this.area.drawRect(0, 0, this.area.width * this.area.scale.x, this.area.height * this.area.scale.y)
    // this.area.beginFill(0x0000ff, 1)
    // this.area.drawCircle(0, 0, 2)
  }

  focus() {
    this.emit('focus')
    if (this.parent.children.length > 1) {
      this.parent.setChildIndex(this, this.parent.children.length - 1)
    }
    this.highlight(true)
  }

  blur() {
    this.emit('blur')
    this.highlight(false)
  }

  highlight(bool = true) {
    if (bool) {
      this.sprite.alpha = 0.9
      this.sprite.tint = 0x66ff66
    } else {
      this.sprite.alpha = 1
      this.sprite.tint = 0xffffff
    }
  }

  flip() {
    if (this.angle % 180 == 0) {
      this.dimension.x *= -1
    } else {
      this.dimension.y *= -1
    }
    this.updateDimension()
  }

  turn() {
    this.angle += 90
    if (this.angle >= 360) {
      this.angle -= 360
    }
    this.updateDimension()
  }

  trash() {
    this.emit('trash')
  }

  roomStick() {
    if (this.room && this.config.type == 'door') {
      // 1マス（補助線）
      let div = grid.size / grid.division
      // くっついて動く幅は1マスの半分
      let move = div / 2
      let angle = this.angle
      if (this.dimension.y < 0) {
        if (angle == 0) angle = 180
        else if (angle == 180) angle = 0
        else if (angle == 90) angle = 270
        else if (angle == 270) angle = 90
      }
      switch (angle) {
        case 0:
          if (this.position.y == 0)
            this.pivot.set(0, move)
          else if (this.position.y + div == this.room.calcHeight)
            this.pivot.set(0, -move)
          else
            this.pivot.set(0)
          break
        case 90:
          if (this.position.x == div - this.calcWidth)
            this.pivot.set(move, 0)
          else if (this.position.x + this.calcWidth == this.room.calcWidth)
            this.pivot.set(-move, 0)
          else
            this.pivot.set(0)
          break
        case 180:
          if (this.position.y == div - this.calcHeight)
            this.pivot.set(0, move)
          else if (this.position.y + this.calcHeight == this.room.calcHeight)
            this.pivot.set(0, -move)
          else
            this.pivot.set(0)
          break
        case 270:
          if (this.position.x == 0)
            this.pivot.set(move, 0)
          else if (this.position.x + div == this.room.calcWidth)
            this.pivot.set(-move, 0)
          else
            this.pivot.set(0)
          break
      }
    } else {
      this.pivot.set(0)
    }
  }

  bindEvents() {
    this.interactive = true
    this.cursor = 'grab'

    this.on('pointerdown', e => {
      e.stopPropagation()
      const anchorPosition = e.data.getLocalPosition(this.parent)
      this.dragStart(new Point(anchorPosition.x - this.x, anchorPosition.y - this.y))
    })
  }

  dragStart(grabPoint = null) {
    this.cursor = 'grabbing'

    this.focus()

    this.emit('grab')

    if (!grabPoint) {
      grabPoint = new Point(this.calcWidth/2, this.calcHeight/2)
    }

    grid.on('pointermove', e => {
      this.emit('drag')
      const anchorPosition = e.data.getLocalPosition(this.parent)
      let div = 1 / grid.division
      this.coordinate.set(
        Math.round((anchorPosition.x - grabPoint.x) / grid.size / div) * div,
        Math.round((anchorPosition.y - grabPoint.y) / grid.size / div) * div
      )
    })

    // エディタ内で離した時
    grid.once('pointerup', e => {
      this.emit('drop')
      this.cursor = 'grab'
      grid.off('pointermove')
      grid.off('pointerupoutside')
    })

    // エディタ外で離した時
    grid.once('pointerupoutside', e => {
      if (e.data.originalEvent.target.tagName != 'CANVAS') {
        this.emit('drop')
        this.cursor = 'grab'
        grid.off('pointermove')
        grid.off('pointerup')
        this.emit('dropout')
      }
    })
  }

  destroy() {
    this.controller.destroy()
    return super.destroy()
  }
}



// WEBPACK FOOTER //
// ./assets/js/display/Item.js